// <zzy-stat-card label="..." value="..." sub="..." color="primary|success|danger|warning|info"></zzy-stat-card>
class ZzyStatCard extends HTMLElement {
  static get observedAttributes() { return ['label','value','sub','color','trend']; }
  connectedCallback() { this.render(); }
  attributeChangedCallback() { this.render(); }
  render() {
    const label = this.getAttribute('label') || '';
    const value = this.getAttribute('value') || '—';
    const sub   = this.getAttribute('sub')   || '';
    const color = this.getAttribute('color') || 'primary';
    const trend = this.getAttribute('trend');
    const palette = {
      primary: { bar: 'var(--zzy-sky)',     text: 'var(--zzy-mist)' },
      success: { bar: 'var(--zzy-success)', text: 'var(--zzy-success)' },
      danger:  { bar: 'var(--zzy-danger)',  text: 'var(--zzy-danger)' },
      warning: { bar: 'var(--zzy-warning)', text: 'var(--zzy-warning)' },
      info:    { bar: 'var(--zzy-info)',    text: 'var(--zzy-info)' }
    };
    const c = palette[color] || palette.primary;

    this.innerHTML = `
      <div style="
        background: var(--zzy-surface);
        backdrop-filter: var(--zzy-blur);
        -webkit-backdrop-filter: var(--zzy-blur);
        border: 1px solid var(--zzy-border);
        border-radius: var(--zzy-radius);
        padding: 20px 24px;
        min-width: 168px;
        flex: 1;
        position: relative;
        overflow: hidden;
        transition: transform var(--zzy-base), border-color var(--zzy-base);
      "
      onmouseover="this.style.borderColor='var(--zzy-border-strong)';this.style.transform='translateY(-2px)'"
      onmouseout="this.style.borderColor='var(--zzy-border)';this.style.transform='translateY(0)'">
        <div style="position:absolute;top:0;left:0;width:48px;height:2px;background:${c.bar};border-radius:0 0 4px 0"></div>
        <div style="font:600 10px/1 var(--zzy-font);color:var(--zzy-text-mute);text-transform:uppercase;letter-spacing:.16em;margin-bottom:14px">${label}</div>
        <div style="font:800 30px/1.05 var(--zzy-font);color:${c.text};letter-spacing:-.025em;display:flex;align-items:baseline;gap:8px">
          ${value}
          ${trend ? `<span style="font:600 13px/1 var(--zzy-font);color:${trend.startsWith('+') ? 'var(--zzy-success)' : 'var(--zzy-danger)'}">${trend}</span>` : ''}
        </div>
        ${sub ? `<div style="font:400 12px/1.4 var(--zzy-font);color:var(--zzy-text-mute);margin-top:8px">${sub}</div>` : ''}
      </div>
    `;
  }
}
customElements.define('zzy-stat-card', ZzyStatCard);
